import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AmPackage, AmPurchaseOrder, PagingData } from '../models';
import { PolarJService } from './polarj.service';
import { MODULE_SERVICE_NAME, PolarJServerModelContextPath } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  private _polarjService: PolarJService = inject(PolarJService);

  public getOrderByPoNumber(poNumber: string): Observable<AmPurchaseOrder> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.API_SHOPPINGCART,
      modelName: PolarJServerModelContextPath.AM_PURCHASE_ORDERS,
      requestMappingString: 'orderandpackage',
      para: poNumber,
      singleData: true,
    });
  }
  public getOrderPackageByPoNumber(poNumber: string): Observable<AmPurchaseOrder> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.API_SHOPPINGCART,
      modelName: PolarJServerModelContextPath.AM_PURCHASE_ORDERS,
      requestMappingString: 'package',
      para: poNumber,
      singleData: true,
    });
  }
  public getOrders(
    searchKey: string,
    pageIndex: number,
    pageSize: number,
    sortField: string = 'orderedDateTime',
    desc: boolean = true,
  ): Observable<PagingData<AmPurchaseOrder>> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.API_SHOPPINGCART,
      modelName: PolarJServerModelContextPath.AM_PURCHASE_ORDERS,
      requestMappingString: 'group',
      urlPara: `field=${sortField}&desc=${desc}`,
      para: {
        smartSearchText: searchKey,
        pageIndex: pageIndex,
        curPageSize: pageSize,
      },
      pageData: true,
    }, true);
  }

  public getTrackingInfo(
    carrier: string,
    trackingNumber: string,
  ): Observable<AmPackage> {
    if(carrier.toUpperCase()=='DHL'){
      carrier='dhlecs';
    }
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.API_TRACKINGINTEGRATION,
      modelName: PolarJServerModelContextPath.AM_TRACK,
      para: {
        trackingInfo: [{ trackingNumber: trackingNumber }],
        carrier: carrier
      },
      singleData: true,
    }, true);
  }
}
